import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="bg-foreground-900 rounded-[40px] overflow-hidden relative">
          <div className="flex flex-col lg:flex-row">
            {/* Image side */}
            <div className="lg:w-[38%] relative min-h-[300px] lg:min-h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=Happy%20customer%20unboxing%20fashion%20items%20at%20modern%20minimal%20desk%20with%20warm%20natural%20window%20light%20genuine%20lifestyle%20moment%20neutral%20tones%20editorial%20candid%20photography%20clean%20composition&width=600&height=700&seq=testimonial-v2-003&orientation=portrait&nocache=true"
                alt="OOPBuy Spreadsheet Nutzer Erfahrung"
                className="w-full h-full object-cover"
                title="OOPBuy Spreadsheet – Zufriedene Nutzer in Deutschland"
                loading="lazy"
              />
            </div>

            {/* Content side */}
            <div className="lg:w-[62%] p-8 md:p-12 lg:p-16 flex flex-col justify-center">
              <div className="text-6xl md:text-8xl text-accent-400/40 font-serif leading-none mb-4">
                &ldquo;
              </div>
              <blockquote className="text-lg md:text-xl text-background-50/90 leading-relaxed mb-8">
                {t('testimonial.quote')}
              </blockquote>
              <div className="mb-8">
                <p className="text-sm font-semibold text-background-50">{t('testimonial.author')}</p>
                <p className="text-xs text-background-50/50">{t('testimonial.role')}</p>
              </div>
              <div>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-400 transition-all cursor-pointer whitespace-nowrap"
                >
                  {t('testimonial.cta')}
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}